/**
 * Normalisation des champs renvoyés par GET /patient/ordonnances/patient/:nip
 * (formes variables selon les versions backend).
 * Après clôture, le backend expose id + consultationId / consultation_id pour l’ordonnance SQL créée ; les
 * consultations anciennes peuvent n’avoir que le complément JSON sans ligne dans cette liste.
 */

function dateToMs(v: unknown): number {
  if (typeof v !== "string") return 0;
  const t = new Date(v).getTime();
  return Number.isNaN(t) ? 0 : t;
}

/** Identifiant d’entité ordonnance exploitable pour POST .../envoyer-pharmacie */
export function extractOrdonnanceEntityId(o: Record<string, unknown>): string {
  const id = o.id ?? o._id;
  if (typeof id === "string" && id.trim()) return id.trim();
  if (typeof id === "number" && Number.isFinite(id)) return String(id);
  return "";
}

/** Identifiant de consultation lié à l’ordonnance (camelCase ou snake_case, string ou nombre). */
export function extractConsultationIdFromOrdonnanceRow(o: Record<string, unknown>): string {
  const v = o.consultationId ?? o.consultation_id ?? o.consultationID;
  if (typeof v === "string" && v.trim()) return v.trim();
  if (typeof v === "number" && Number.isFinite(v)) return String(v);
  return "";
}

/**
 * Filtre les lignes pour une consultation donnée.
 * Si aucune liaison explicite : repli sur l’unique ordonnance avec id, sinon la plus récente par date.
 */
export function filterOrdonnanceRowsForConsultation(rows: unknown[], consultationId: string): unknown[] {
  const target = consultationId.trim();
  if (!target) return [];

  const objects = rows.filter((r): r is Record<string, unknown> => Boolean(r && typeof r === "object" && !Array.isArray(r)));

  const byConsult = objects.filter((o) => {
    const cid = extractConsultationIdFromOrdonnanceRow(o);
    return cid === target;
  });
  if (byConsult.length > 0) return byConsult;

  const withId = objects.filter((o) => extractOrdonnanceEntityId(o));
  if (withId.length === 1) return withId;

  if (withId.length > 1) {
    const scored = withId.map((o) => ({
      o,
      t: dateToMs(o.datePrescription ?? o.date ?? o.createdAt ?? o.updatedAt),
    }));
    scored.sort((a, b) => b.t - a.t);
    return [scored[0].o];
  }

  return [];
}
